import { css } from "styled-components";
import { MixinIcon } from "../../../../components/Icon/skins/common";
export const riotProductSkin = (chroma, paletteTokens) => css `
  & {
    background-color: ${paletteTokens.bladebg1};
    padding: ${chroma.spacers.bladeEdge.top} 0 ${chroma.spacers.bladeEdge.bottom};
  }

  button {
    :focus {
      outline: 2px solid ${paletteTokens.accents1};
    }
  }

  .audio-player-container {
    display: grid;
    grid-template-areas:
      "play-pause progress-container audio-player-right-addons"
      "audio-player-caption audio-player-caption audio-player-caption";
    grid-template-columns: auto 1fr auto;
    align-items: center;
    column-gap: ${chroma.spacers.variable.m};
  }

  .play-pause-bg {
    height: 56px;
    width: 56px;
    ${chroma.mediaQueries.mobileDown} {
      height: 40px;
      width: 40px;
    }

    ${MixinIcon({ icon: chroma.icons.rhombus, color: paletteTokens.accents1 })};
    .pause,
    .play {
      height: 100%;
      width: 100%;
    }

    .pause {
      ${MixinIcon({ icon: chroma.icons.pause, color: paletteTokens.bladebg1 })};
    }

    .play {
      ${MixinIcon({ icon: chroma.icons.play, color: paletteTokens.bladebg1 })};
    }
  }

  .mute-unmute {
    height: 24px;
    width: 24px;

    .mute,
    .unmute {
      height: 24px;
      width: 24px;
    }

    .mute {
      ${MixinIcon({ icon: chroma.icons.volumeUp, color: paletteTokens.accents1 })};
    }

    .unmute {
      ${MixinIcon({ icon: chroma.icons.volumeDown, color: paletteTokens.accents1 })};
    }
  }

  .remaining-time {
    ${chroma.typography.body5};
    /* to prevent layout shift */
    min-width: 4em;
    text-align: center;
  }

  .audio-player-caption {
    grid-area: audio-player-caption;
    text-align: center;
    ${chroma.typography.body4};
  }

  .progress-container {
    grid-area: progress-container;
    width: 100%;
    height: 2px;
    background-color: ${paletteTokens.keyline};

    .progress-bar {
      height: 100%;
      background-color: ${paletteTokens.accents1};
    }
  }

  .audio-player-right-addons {
    grid-area: audio-player-right-addons;
    display: flex;
    align-items: center;
    gap: ${chroma.spacers.constant.xs};
  }
`;
//# sourceMappingURL=index.js.map